<script>
  import {
    Card,
    Accordion,
    Button,
    Text,
    Image,
    Title,
  } from "@svelteuidev/core";
  import Constantes from "../../Classes/Constantes";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import DropDownDB from "../../componentes_basicos/DropDownDB.svelte";
  import { onMount } from "svelte";
  import { permissaoUsuario } from "../../Classes/Stores";
  import TelasAcessoNaoAutorizado from "../TelasAcessoNaoAutorizado.svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";

  const conexao = new Conexoes();

  let isLoading = false;
  export let resultados = [];
  export let params;
  let id_campeonato = params;
  let config_campeonato = {
    api: Constantes.api_consultar_padrao,
    parametros: {
      query_code: "consultar_todos_campeonatos",
    },
    nome_coluna_opcoes: "nome_campeonato",
    nome_coluna_saida: "id",
    filtravel: false,
    itens: "",
  };
  // Agrupar resultados por sigla e por atleta
  let groupedResultsBySigla = {};
  let provasPorSigla = {}; // Para armazenar as provas por sigla

  async function PegarDados() {
    isLoading = true;
    resultados = [];
    resultados = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "consulta_ranking_final",

      id_campeonato: id_campeonato,
    });

    // Agrupar resultados por sigla e atleta
    resultados.forEach((result) => {
      const siglaKey = result.sigla;
      const atletaKey = result.atletas;

      // Se a sigla ainda não foi adicionada, inicializa
      if (!groupedResultsBySigla[siglaKey]) {
        groupedResultsBySigla[siglaKey] = {};
        provasPorSigla[siglaKey] = []; // Armazena as provas por sigla
      }

      // Se o atleta ainda não foi adicionado na sigla, inicializa
      if (!groupedResultsBySigla[siglaKey][atletaKey]) {
        groupedResultsBySigla[siglaKey][atletaKey] = {
          pontuacoes: {}, // Objeto para armazenar pontuações por prova
          pontuacao: result.soma_posicoes, // Exemplo, ajuste conforme a lógica
          posicao: result.posicao,
          pontuacao_geral: result.pontuacao_geral,
          posicao_geral: result.posicao_geral,
        };
      }

      // Adiciona a pontuação da prova
      groupedResultsBySigla[siglaKey][atletaKey].pontuacoes[result.nome_prova] =
        {
          posicao: result.posicao,
          pontuacao: result.pontuacao || 0, // Valor padrão 0 se não houver
             pontuacao_geral: result.pontuacao_geral,
             posicao_geral: result.posicao_geral,
        };

      // Adiciona a prova se ainda não estiver adicionada na sigla
      if (!provasPorSigla[siglaKey].includes(result.nome_prova)) {
        provasPorSigla[siglaKey].push(result.nome_prova);
      }
    });

    isLoading = false;
  }

  onMount(() => {
    if (id_campeonato) {
      PegarDados();
    }
  });
  function RetornaDrops(e) {
    id_campeonato = e.detail.objeto.id;
    PegarDados();
  }
</script>

{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_ver_ranking_final)}
  <br />
  <br />
  <br />
   <LoadingTela {isLoading}/>
  <div class="ranking-container">
    {#if !params}
    <label>Selecione o campeonato</label>
      <DropDownDb config={config_campeonato} on:retorno={RetornaDrops} />
    {/if}
    {#if id_campeonato}
      
       
     
        {#each Object.keys(groupedResultsBySigla) as sigla}
          <!-- Início do bloco de sigla -->
          <div class="sigla-header">Categoria: {sigla}</div>

          <table class="table">
            <thead>
              <tr>
                <th>Pos.</th>
                <th>Atleta</th>
                {#each provasPorSigla[sigla] as prova}
                  <th>{prova}</th> <!-- Nome da prova -->
                {/each}
                <th>Pontuação Geral</th>
              </tr>
            </thead>
            <tbody>
              {#each Object.keys(groupedResultsBySigla[sigla]) as atleta, idx}
                <tr>
                  <td>{groupedResultsBySigla[sigla][atleta].posicao_geral}º</td>
               
                  <td>{atleta}</td>
                  <!-- Nome do atleta -->
                  {#each provasPorSigla[sigla] as prova}
                    <td>
                      {#if groupedResultsBySigla[sigla][atleta].pontuacoes[prova]}
                       {groupedResultsBySigla[sigla][atleta]
                          .pontuacoes[prova].posicao}º
                      {:else}
                        Aguardando
                      {/if}
                    </td>
                  {/each}
                
                  <td>{groupedResultsBySigla[sigla][atleta].pontuacao_geral}</td
                  >
                 

                  
                </tr>
              {/each}
            </tbody>
          </table>

          <!-- Fim do bloco de sigla -->
        {/each}
     
    {/if}
  </div>
  <br />
  <br />
  <br />
{:else}
  <TelasAcessoNaoAutorizado />
{/if}

<style>
  .ranking-container {
    margin: 20px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #f9f9f9;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  .table th {
    background-color: #f2f2f2;
    font-weight: bold;
  }

  .sigla-header {
    margin-top: 30px;
    font-size: 1.2em;
    font-weight: bold;
    color: #333;
  }
</style>
